import { useEffect } from 'react';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';
import { useGetConfigEmailQuery, useUpdateConfigEmailMutation } from '../store/config-api';

import type { TConfigEmail } from '../store/types';

type FormData = TConfigEmail;

export const useConfigEmail = () => {
  const {
    data,
    isLoading: isGetLoading,
    isSuccess: isGetSuccess,
    isError: isGetError,
  } = useGetConfigEmailQuery();

  const [updateEmail, {
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess,
    isError: isUpdateError,
  }] = useUpdateConfigEmailMutation();

  const isLoading = isGetLoading || isUpdateLoading;
  const isSuccess = isUpdateSuccess;
  const isError = isGetError || isUpdateError;

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      smtpAddress: data?.smtpAddress || '',
      smtpPort: data?.smtpPort || '',
      login: data?.login || '',
      password: data?.password || '',
      emailProxyUrl: data?.emailProxyUrl || '',
    },
    validate: {
      smtpAddress: (value) => value.length < 1 ? 'Введите SMTP адрес' : null,
      smtpPort: (value) => value.length < 1 ? 'Введите SMTP port' : null,
      login: (value) => value.length < 1 ? 'Введите логин' : null,
      password: (value) => value.length < 1 ? 'Введите пароль' : null,
      emailProxyUrl: (value) => value.length < 1 ? 'Введите email proxy url' : null,
    },
  });

  useEffect(() => {
    if (isGetSuccess) {
      form.setValues({ ...data });
    }
  }, [isGetSuccess]);

  const handleEmailUpdate = async (params: TConfigEmail) => {
    await updateEmail(params);
  };

  const handleSubmit = (values: FormData) => {
    modals.openConfirmModal({
      title: 'Сохранение Email настроек',
      centered: true,
      children: 'Вы точно хотите сохранить настройки Email?',
      labels: { confirm: 'Подтвердить', cancel: 'Отмена' },
      confirmProps: { color: 'blue' },
      onConfirm: () => handleEmailUpdate(values),
    });
  };

  return {
    // data,
    isLoading,
    form,
    // updateBaseUrl,
    // handleBaseUrlUpdate,
    handleSubmit,
  };
};
